import React, { useEffect, useState } from 'react';
import { Sparkles, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'habita_beta_banner_dismissed_v1';

export default function BetaBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const dismissed = localStorage.getItem(STORAGE_KEY) === '1';
      setVisible(!dismissed);
    } catch {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    setVisible(false);
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch {}
  };

  if (!visible) return null;

  return (
    <div
      data-testid="beta-banner"
      className="relative w-full bg-habita-dark text-white border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-2.5 flex items-center justify-center gap-3 text-center">
        <Sparkles className="w-3.5 h-3.5 text-amber-300 shrink-0 hidden sm:inline" />
        <p className="text-[12px] sm:text-[13px] tracking-wide leading-tight">
          <span className="font-semibold text-amber-300 uppercase tracking-widest mr-2 text-[10px] sm:text-[11px]">Beta privada</span>
          <span className="text-white/85">Acceso gratuito para los primeros propietarios y agentes registrados.</span>
          <Link
            to="/registro"
            className="ml-2 sm:ml-3 underline underline-offset-2 decoration-amber-300/60 hover:decoration-amber-300 font-semibold text-amber-200 whitespace-nowrap"
            data-testid="beta-banner-cta"
          >
            Solicitar acceso →
          </Link>
        </p>
        <button
          onClick={dismiss}
          aria-label="Cerrar banner"
          data-testid="beta-banner-dismiss"
          className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 p-1 rounded-full hover:bg-white/10 transition-colors"
        >
          <X className="w-3.5 h-3.5 text-white/60" />
        </button>
      </div>
    </div>
  );
}
